import type { VoidFunctionComponent } from 'react';

import List from '../../../generic/List';
import DependencyTableContents from '../DependenciesTable/DependencyTableContents';
import type { ManuallyAddedDependencyRequestKind } from '../../../../../typings/api';
import type { DependencyV2Modals } from '../hooks/useDependencyModals';
import type { DependencyToRemove } from '../modals/RemoveDependency';

import styles from './VendoredDependenciesLayout.module.less';

type Props = {
  modals: DependencyV2Modals;
  setSelectedDependencyRevisionLocator: (locator: string) => void;
  setDependencyToRemove: (dependency: DependencyToRemove | null) => void;
  setDependencyLocatorToOverwrite: (locator: string | null) => void;
  setDependencyLocatorToEdit: (locator: string | null) => void;
  setManualDependencyAddMode: (mode: ManuallyAddedDependencyRequestKind | null) => void;
  setInProgressBuildId: (buildId: number | null) => void;
};

/**
 * Table contents for vendored dependencies view.
 * Renders dependency rows without the List.Header (header is in TreeViewLayout.Table).
 */
const VendoredTableContents: VoidFunctionComponent<Props> = ({
  modals,
  setSelectedDependencyRevisionLocator,
  setDependencyToRemove,
  setDependencyLocatorToOverwrite,
  setDependencyLocatorToEdit,
  setManualDependencyAddMode,
  setInProgressBuildId,
}) => {
  return (
    <List isBorderless className={styles.borderlessList}>
      <List.Body>
        <DependencyTableContents
          modals={modals}
          setSelectedDependencyRevisionLocator={setSelectedDependencyRevisionLocator}
          setDependencyToRemove={setDependencyToRemove}
          setDependencyLocatorToOverwrite={setDependencyLocatorToOverwrite}
          setDependencyLocatorToEdit={setDependencyLocatorToEdit}
          setManualDependencyAddMode={setManualDependencyAddMode}
          setInProgressBuildId={setInProgressBuildId}
        />
      </List.Body>
    </List>
  );
};

export default VendoredTableContents;
